import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { get } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { deletePortfolio } from '../../../http/PortfoliosApi';

export default function DeletePortfolioDialog({
  activePortfolioId,
  portfolioName,
  setPortfolios,
  deletePortfolioDialogOpen,
  setDeletePortfolioDialogOpen,
  portfolios,
  errMessage,
  setErrMessage,
  setSnackOpen,
}) {
  const navigate = useNavigate();
  const handleDeletePortfolioSubmit = async (event) => {
    event.preventDefault();

    try {
      await deletePortfolio(activePortfolioId);
      setPortfolios(portfolios.filter((p) => p !== activePortfolioId));
      setDeletePortfolioDialogOpen(false);
      navigate('/');
      window.location.reload(false);
    } catch (err) {
      setErrMessage(get(err, 'response.data.message', errMessage));
      setSnackOpen(true);
    }
  };

  return (
    <Dialog
      fullWidth
      open={deletePortfolioDialogOpen}
      onClose={() => setDeletePortfolioDialogOpen(false)}
    >
      <form onSubmit={handleDeletePortfolioSubmit}>
        <DialogTitle>Delete portfolio?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            This action cannot be undone.{' '}
            {portfolioName ? (
              <>
                The portfolio <strong>{portfolioName}</strong>
              </>
            ) : (
              'This portfolio'
            )}{' '}
            and all of its data will be permanently deleted.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDeletePortfolioDialogOpen(false)}
            color="inherit"
          >
            Cancel
          </Button>
          <Button type="submit" variant="contained" color="error">
            Delete portfolio
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
